import React from 'react';
import _ from 'lodash';
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import CategoryItem from '../CategoryItem';
import AddAssetButton from "../../../../components/AddAssetButton";

import useStyles from './styles';

const getSizeByIdx = (index, total) => {
  return (index === 0 || (index === 1 && (total === 2 || total === 4))) ? 12 : 6;
};

const AssetsCategories = (props) => {
  const classes = useStyles();

  const {
    categories,
    setActiveCategory,
    onAddAssetClick,
  } = props;

  const total = categories.length;

  // FIXME: why we show btn without onAddAssetClick?
  const handleAddAssetClicked = () => {
    if (!_.isNil(onAddAssetClick)) {
      onAddAssetClick();
    }
  };

  return (
    <>
      <Grid container className={classes.container}>
        {categories.map((category, idx) => (
          <Grid key={category.id} item xs={12} md={getSizeByIdx(idx, total)} className={clsx(classes.itemWrapper, idx === 0 ? classes.firstItem : '')}>
            <CategoryItem
              title={category.title}
              totalAmount={category.total_value}
              icon={category.icon}
              url={category.url}
              read_only={category.read_only}
              setActiveCategory={!_.isNil(setActiveCategory) ? () => setActiveCategory(category.id) : undefined}
            />
          </Grid>
        ))}
      </Grid>
      <div className={classes.itemWrapper}>
        <AddAssetButton onButtonClick={handleAddAssetClicked} />
      </div>
    </>
  )
};

export default AssetsCategories;